export default (virtualPageName, virtualPageUrl) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'VirtualPageview',
      'virtualPageUrl': virtualPageUrl,
      'virtualPageName': virtualPageName
    })
  }
}
